module.exports = function() {
  return new Worker(__webpack_public_path__ + "eb5f2dd119e0f05d9a3c.worker.js");
};